import axios from "./axiosInstance";

const achievementAPI ={ 
   achievements_listing: () => axios.get("achievements"),
    
}

export default achievementAPI;